// src/services/captcha.service.ts

type CaptchaState = {
    token: string | null;
};

class CaptchaService {
    private state: CaptchaState = {
        token: null
    };

    /**
     * Called by Cloudflare Turnstile callback
     */
    setToken(token: string) {
        this.state.token = token;
    }

    /**
     * Returns the current token (single-use)
     */
    consumeToken(): string | null {
        const token = this.state.token;
        this.state.token = null; // 🔒 prevent reuse
        return token;
    }

    /**
     * Reset captcha manually (optional)
     */
    reset() {
        this.state.token = null;

        // Reset Turnstile widget if present
        if ((window as any).turnstile) {
            (window as any).turnstile.reset();
        }
    }

    /**
     * Check if token exists (UI logic only)
     */
    hasToken(): boolean {
        return this.state.token !== null;
    }
}

// src/services/captcha.service.ts
export async function getCaptchaToken(): Promise<string> {
    return new Promise((resolve, reject) => {
        if (!(window as any).turnstile) {
            reject("Turnstile not loaded");
            return;
        }

        (window as any).turnstile.execute("#cf-turnstile", {
            callback: (token: string) => resolve(token),
            "error-callback": () => reject("Captcha failed"),
            "expired-callback": () => reject("Captcha expired")
        });
    });
}


export const captchaService = new CaptchaService();
